import { Loader, Wrapper } from "./LayoutLoader.styled";

export const LayoutLoader = () => {
  return (
    <Wrapper>
      <Loader />
    </Wrapper>
  );
};
